<script>
import BaseFilterSingle from "./BaseFilterSingle";
import { mapGetters } from "vuex";

export default {
  name: "Creator",
  extends: BaseFilterSingle,
  computed: {
    ...mapGetters({
      options: "users_flattened"
    })
  },
  data() {
    return {
      placeholder: "Aanmaker",
      filtername: "creator_uuid",
      type: "creator",
      multiple: false // backend can only filter on one creator_uuid
    };
  },
  created: function() {
    this.$store.dispatch("loadUsers");
  }
};
</script>
